export const REQUEST_AUDIT_LOGS = 'audit/REQUEST_AUDIT_LOGS';
export const RECEIVED_AUDIT_LOGS = 'audit/RECEIVED_AUDIT_LOGS';
export const ERROR_AUDIT_LOGS = 'audit/ERROR_AUDIT_LOGS';

export const REQUEST_LEAD_AUDIT_LOGS = 'audit/REQUEST_LEAD_AUDIT_LOGS';
export const RECEIVED_LEAD_AUDIT_LOGS = 'audit/RECEIVED_LEAD_AUDIT_LOGS';
export const ERROR_LEAD_AUDIT_LOGS = 'audit/ERROR_LEAD_AUDIT_LOGS';
